export const DICTIONARY_CL = {
  schedule: {
    day: 'día',
    week: 'semana',
    workWeek: 'Semana de trabajo',
    month: 'Mes',
    agenda: 'Agenda',
    weekAgenda: 'Agenda de la semana',
    workWeekAgenda: 'Agenda de la Semana de Trabajo',
    monthAgenda: 'Agenda del mes',
    today: 'Hoy',
    noEvents: 'No hay eventos',
    allDay: 'Todo el dia',
    start: 'Comienzo',
    end: 'Fin',
    more: 'Más',
    close: 'Cerrar',
    cancel: 'Cancelar',
    noTitle: '(Sin título)',
    delete: 'Borrar',
    deleteEvent: 'Eliminar evento',
    selectedItems: 'Repuestos seleccionados',
    deleteSeries: 'Eliminar serie',
    edit: 'Editar',
    editSeries: 'Editar serie',
    editEvent: 'Editar evento',
    createEvent: 'Crear',
    subject: 'Tema',
    addTitle: 'Añadir título',
    moreDetails: 'Más detalles',
    save: 'Salvar',
    editContent: 'Quieres editar solo este evento o toda la serie?',
    deleteRecurrenceContent: 'Desea eliminar solo este evento o toda la serie?',
    deleteContent: 'Seguro que quieres eliminar este evento?',
    newEvent: 'Nuevo evento',
    title: 'Título',
    location: 'Ubicación',
    description: 'Descripción',
    timezone: 'Zona horaria',
    startTimezone: 'Hora de inicio',
    endTimezone: 'Fin de zona horaria',
    repeat: 'Repetir',
    saveButton: 'Salvar',
    cancelButton: 'Cancelar',
    deleteButton: 'Borrar',
    recurrence: 'Reaparición',
    editRecurrence: 'Editar recurrencia',
    repeats: 'Repite',
    alert: 'Alerta',
    groups: 'operarios',
    startEndError: 'La fecha de finalización seleccionada ocurre antes de la fecha de inicio.',
    invalidDateError: 'El valor de la fecha ingresada no es válido.',
    ok: 'De acuerdo',
  },
  recurrenceeditor: {
    none: 'Ninguna',
    daily: 'Diario',
    weekly: 'semanal',
    monthly: 'Mensual',
    month: 'Mes',
    yearly: 'Anual',
    never: 'Nunca',
    until: 'Hasta',
    count: 'Contar',
    first: 'Primero',
    second: 'Segundo',
    third: 'Tercero',
    fourth: 'Cuarto',
    last: 'Último',
    repeat: 'Repetir',
    repeatEvery: 'Repite cada',
    on: 'Repita en',
    end: 'Fin',
    onDay: 'Día',
    days: 'Dias)',
    weeks: 'Semanas)',
    months: 'Meses)',
    years: 'Años)',
    every: 'cada',
    summaryTimes: 'veces)',
    summaryOn: 'en',
    summaryUntil: 'hasta',
    summaryRepeat: 'Repite',
    summaryDay: 'dias)',
    summaryWeek: 'semanas)',
    summaryMonth: 'meses)',
    summaryYear: 'años)',
  },
  calendar: {
    today: 'hoy',
  },
  datepicker: {
    today: 'Hoy',
  },
  grid: {
    EmptyRecord: 'No hay resultados',
    True: 'verdadero',
    ShowRowsWhere: 'Enseñar lineas donde:',
    Add: 'Añadir',
    Edit: 'Editar',
    Cancel: 'Cancelar',
    Update: 'Actualizar',
    Delete: 'Borrar',
  },
  pager: {
    currentPageInfo: '{0} de {1} páginas',
    totalItemsInfo: '({0} registros)',
    firstPageTooltip: 'Ir a la primera página',
    lastPageTooltip: 'Ir a la última página',
    nextPageTooltip: 'Ir a la próxima página',
    previousPageTooltip: 'Ir a la página anterior',
    nextPagerTooltip: 'Go to next pager',
    previousPagerTooltip: 'Go to previous pager',
    pagerDropDown: 'Ítems por página',
    pagerAllDropDown: 'Ítems',
    All: 'Todo',
  },
  dropdowns: {
    noRecordsTemplate: 'Sin registros',
    actionFailureTemplate: 'Error en el modelo',
    overflowCountTemplate: '+${count} más..',
    totalCountTemplate: '${count} seleccionado',
  },
};
